import { InAppNotificationType, NotificationType } from "@hex/common";
import React from "react";

import {
  ArchiveIcon,
  ComponentIcon,
  KeyIcon,
  LinkIcon,
  ScheduledRunsIcon,
} from "../icons/CustomIcons.js";

// Not all of these icons are used if a notification type has a user, but
// including all notification types here just to satfisfy types/without having
// to add additional types.
export const NotificationTypeToIcon: Record<
  InAppNotificationType,
  React.ReactNode
> = {
  [NotificationType.COMMENT]: null,
  [NotificationType.TEXT_CELL_MENTION]: null,
  [NotificationType.ADMIN_HEX_ROLE_GRANTED]: null,
  [NotificationType.SCHEDULED_RUN_SUCCESS]: <ScheduledRunsIcon />,
  [NotificationType.SCHEDULED_RUN_FAILURE]: <ScheduledRunsIcon />,
  [NotificationType.FINAL_TOKEN_EXPIRATION]: <KeyIcon />,
  [NotificationType.HEX_ROLE_REQUEST]: null,
  [NotificationType.INITIAL_TOKEN_EXPIRATION]: <KeyIcon />,
  [NotificationType.INITIAL_OAUTH_TOKEN_EXPIRATION]: <KeyIcon />,
  [NotificationType.FINAL_OAUTH_TOKEN_EXPIRATION]: <KeyIcon />,
  [NotificationType.ORG_ROLE_REQUEST]: null,
  [NotificationType.PROJECT_SHARE]: null,
  [NotificationType.REVIEW_REQUESTED]: null,
  [NotificationType.REVIEW_REQUEST_RESOLVED]: null,
  [NotificationType.REVIEW_CREATED]: null,
  [NotificationType.CONNECTED_APP]: <LinkIcon />,
  [NotificationType.ARCHIVE_DIGEST]: <ArchiveIcon />,
  [NotificationType.PROJECT_LIFECYCLE]: <ArchiveIcon />,
  [NotificationType.COMPONENT_UPGRADE_AVAILABLE]: <ComponentIcon />,
  [NotificationType.COMPONENT_IMPORT_CELL_UPDATED]: <ComponentIcon />,
};
